import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import moment from 'moment';
import { ChartService } from '@app/data/services/chartService';
import { FilterService } from '@app/data/services/filterService';
import { SitesService } from '@app/data/services/sitesService';
import WeatherChartConfig from '@app/data/widget-config-templates/weather-chart';
import { formatDate, getChartConfig } from './weather-chart-helpers';

@Component({
  selector: 'app-weather-historical-chart',
  templateUrl: './weather-chart.component.html',
  styleUrls: ['./weather-chart.component.scss'],
})
export class WeatherHistoricalChartComponent implements OnInit {
  chartTitle: string = 'Weather - Historic';
  chartOptions: any = WeatherChartConfig;
  id: string = 'weather-chart-historical';
  startDate: any = '';
  endDate: any = '';
  noData: boolean = true;

  constructor(
    private chartService: ChartService,
    private filterService: FilterService,
    private sitesService: SitesService
  ) {}

  ngOnInit() {
    this.filterService.subscribe(this.handleFilterUpdate);
    this.sitesService.subscribe(this.handleSiteUpdate);
    this.startDate = formatDate(this.filterService.getFilters().fromDate);
    this.endDate = formatDate(this.filterService.getFilters().toDate);
    this.setData();
  }

  setData = () => {
    this.chartService
      .getHistoricalWeatherData(moment(this.startDate).format('YYYY-MM-DD'), moment(this.endDate).format('YYYY-MM-DD'))
      .subscribe((data) => {
        this.noData = data.length === 0;
        this.chartOptions = getChartConfig(WeatherChartConfig, data, 'weather-historical');
      });
  };

  handleSiteUpdate = ({ site }: any) => {
    if (site) {
      this.setData();
    }
  };

  handleFilterUpdate = (filters: any) => {
    if (!filters.filters.fromDate || !filters.filters.toDate) return; // Bail out until we have full date range

    const newStartDate = formatDate(filters.filters.fromDate);
    const newEndDate = formatDate(filters.filters.toDate);
    if ((newStartDate !== this.startDate || newEndDate !== this.endDate) && !!newStartDate && !!newEndDate) {
      this.startDate = newStartDate;
      this.endDate = newEndDate;
      this.setData();
    }
  };
}
